<template>
  <div>
	<div v-html="params['content']">
		
	</div>
	
  </div>
</template>
<script>
export default {
  name: 'strategic_principles',
  props: ['params']
}
</script>
<style>

</style>